import React, { Component } from 'react';
import styled from 'styled-components'
import CaDetDebtorComponent from './components/infogrids/CaDetDebtorComponent';
import CaDetFakturaerComponent from './components/tabs/CaDetFakturaerComponent';
import CaDetMeldingListComponent from './components/tabs/CaDetMeldingListComponent'
import CaDetAktiviteterComponent from './components/tabs/CaDetAktiviteterComponent';
import CaDetNotaterComponent from './components/tabs/CaDetNotaterComponentDeprecated';
import CaDetReskontroComponent from './components/infogrids/CaDetReskontroComponent';
import CaDetHeaderComponent from './components/infogrids/CaDetHeaderComponent';
import CaDetSamleSakComponent from './components/tabs/CaDetSamleSakComponent';
import CaDetSaksOversiktComponent from './components/infogrids/CaDetSaksOversiktComponent';

const ReportWrapper = styled.div`
    /* Må ha for at componentene på skjermen skal være korrekt */
    display: none;

    @media print {
        display: block !important;

        color: #000 !important;
        background: #fff !important;
        -webkit-print-color-adjust: exact !important;

        .PrintSection {
            padding: 40px !important;
        }

        /* Bruker @font-face for at teksten skal være synlig i Chrome i preview (gir den tid til å laste inn), Firefox fungerer uten */
        @font-face {
            font-family: 'Roboto';
            font-display: swap; // <- Denne er viktig for at fonten skal vises i Chrome i preview
            src: local('Roboto'), url(./fonts/Roboto.otf) format('opentype');
        }
    }
`;

const ReportSpacer = styled.div`
    min-height: 20px;
`

export class CaseDetailsReportComponentToPrint extends Component {
    render() {
        return (
            // <div ref={this.props.innerRef}>
                <ReportWrapper>

                    <CaDetHeaderComponent />
                    <ReportSpacer />

                    <CaDetReskontroComponent />
                    <ReportSpacer />

                    <CaDetDebtorComponent />
                    <ReportSpacer />

                    <CaDetSaksOversiktComponent />
                    <ReportSpacer />

                    <CaDetFakturaerComponent isReport={true} />
                    <ReportSpacer />

                    <CaDetMeldingListComponent isReport={true} /> 
                    <ReportSpacer />
            
                    {/* 
                    <CaDetNotaterComponent isReport={true} />
                    <ReportSpacer />
                    */}
                    
                    <CaDetAktiviteterComponent isReport={true} />
                    <ReportSpacer />

                    <CaDetSamleSakComponent isReport={true} />

                </ReportWrapper>
            // </div>
        );
    }
}

// Create Document Component
export const CaseDetailsReport = () => {

    return (
        
        <ReportWrapper>
            
            <CaDetHeaderComponent />

            <CaDetReskontroComponent />

            <CaDetDebtorComponent />

            <CaDetFakturaerComponent isReport={true}/>

            <CaDetAktiviteterComponent isReport={true}/>

            <CaDetNotaterComponent isReport={true}/>

        </ReportWrapper>

    )
}